var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2743 1.315L8.83539 8.62763C8.33856 9.11602 8.05658 9.78921 8.05658 10.4888V23.6753C8.05658 25.1273 9.26507 26.3152 10.7421 26.3152H22.827C23.9012 26.3152 24.868 25.6817 25.2977 24.7181L29.6751 14.6731C30.803 12.0596 28.856 9.15562 25.9691 9.15562H18.3824L19.6581 3.11016C19.7923 2.45017 19.5909 1.77699 19.1075 1.3018C18.3153 0.536213 17.0531 0.536213 16.2743 1.315ZM2.68553 26.3152C4.16257 26.3152 5.37106 25.1273 5.37106 23.6753V13.1155C5.37106 11.6636 4.16257 10.4756 2.68553 10.4756C1.20849 10.4756 0 11.6636 0 13.1155V23.6753C0 25.1273 1.20849 26.3152 2.68553 26.3152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.a1ea429abe538cf79b0ccbf670af0782.svg";
export { ForwardRef as ReactComponent };